<template>
    <BaseModal
        :show="show"
        title="Return Home?"
        confirmText="Yes"
        cancelText="No"
        :useTimer="true"
        @confirm="$emit('confirm')"
        @cancel="handleCancel"
        ref="baseModal"
    >
        Do you want to close <strong>{{ appName }}</strong> and return to the home screen?
    </BaseModal>
</template>

<script setup>
import {ref, watch} from 'vue';
import BaseModal from './BaseModal.vue';

function getButtons() {
    return [confirmButton.value, cancelButton.value].filter(Boolean);
}

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    appName: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['confirm', 'cancel']);
const baseModal = ref(null);
const confirmButton = ref(null);
const cancelButton = ref(null);
const previouslyFocused = ref(null);

const handleCancel = () => {
	if (previouslyFocused.value) {
		previouslyFocused.value.focus();
	}
	emit('cancel');
};

watch(() => props.show, (newVal) => {
	if (newVal) {
		previouslyFocused.value = document.activeElement;
	} else {
		previouslyFocused.value = null;
	}
});

// Expose the animateModalClose method from BaseModal
defineExpose({
    getButtons,
    animateModalClose: () => baseModal.value?.animateModalClose()
});
</script>